export const getSeriesMatchID = (seriesSlug, matchSlug) => {
  if(!seriesSlug || !matchSlug) return { seriesId: null, matchId: null };
  const matchIdAry = matchSlug.split("-");
  const seriesIdAry = seriesSlug.split("-");
  const matchId = matchIdAry.length > 0 ? matchIdAry[matchIdAry.length - 1] : "0";
  const seriesId = seriesIdAry[seriesIdAry.length - 1];
  return { seriesId, matchId };
}